import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestRestoreDriver } from "./restoreDriver.request";

const useRestoreDriver = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchDrivers = useRefetchQuery(["driver"]);

  return useMutation({
    mutationFn: requestRestoreDriver,
    ...options,
    onSuccess: (...args) => {
      refetchDrivers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useRestoreDriver;
